module.exports = __webpack_public_path__ + "img/icon-failed-full.71b91db3.svg";